import React from "react";
import cn from "classnames";
import styles from "./Travel.module.sass";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import Icon from "../Icon";
import Image from "../Image";

const items = [
  {
    title: "Myth 1: You need prior experience!",
    content: "No! You don’t need prior experience to try ANY offbeat sport.",
    color: "#8BC5E5",
  },
  {
    title: "Myth 2: Swimming is Mandatory ",
    content:
      "No! Knowledge of swimming is not a prerequisite for ‘LEISURE’ watersports.",
    color: "#92A5EF",
  },
  {
    title: "Myth 3: Fitness is important!",
    content:
      "No! You don’t need to be an athlete or have a fit bod to get started.",
    color: "#58C27D",
  },
  {
    title: "Myth 4: Offbeat is not safe",
    content:
      "Safety first - our partners are certified, and have professional instructors.",
    color: "#58C27D",
  },
];

const gallery = [
  {
    src: "/images/content/sportify-group-1.jpg",
    srcSet: "/images/content/sportify-group-1.jpg",
    // srcSet: "/images/content/sportify-group-1@2x.jpg",
    images: [
      {
        src: "/images/content/appraisal-pic-1.png",
        srcSet: "/images/content/appraisal-pic-1@2x.png",
        srcDark: "/images/content/appraisal-pic-dark-1.png",
        srcSetDark: "/images/content/appraisal-pic-dark-1@2x.png",
      },
      {
        src: "/images/content/appraisal-pic-1.png",
        srcSet: "/images/content/appraisal-pic-1@2x.png",
        srcDark: "/images/content/appraisal-pic-dark-1.png",
        srcSetDark: "/images/content/appraisal-pic-dark-1@2x.png",
      },
      {
        src: "/images/content/appraisal-pic-1.png",
        srcSet: "/images/content/appraisal-pic-1@2x.png",
        srcDark: "/images/content/appraisal-pic-dark-1.png",
        srcSetDark: "/images/content/appraisal-pic-dark-1@2x.png",
      },
    ],
  },
  // {
  //   src: "/images/content/travel-pic-1.jpg",
  //   srcSet: "/images/content/travel-pic-1@2x.jpg",
  //   images: [
  //     {
  //       src: "/images/content/appraisal-pic-1.png",
  //       srcSet: "/images/content/appraisal-pic-1@2x.png",
  //       srcDark: "/images/content/appraisal-pic-dark-1.png",
  //       srcSetDark: "/images/content/appraisal-pic-dark-1@2x.png",
  //     },
  //     {
  //       src: "/images/content/appraisal-pic-1.png",
  //       srcSet: "/images/content/appraisal-pic-1@2x.png",
  //       srcDark: "/images/content/appraisal-pic-dark-1.png",
  //       srcSetDark: "/images/content/appraisal-pic-dark-1@2x.png",
  //     },
  //   ],
  // },
];

const SlickArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <button {...props}>{children}</button>
);

const Travel = () => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
    nextArrow: (
      <SlickArrow>
        <Icon name="arrow-next" size="14" />
      </SlickArrow>
    ),
    prevArrow: (
      <SlickArrow>
        <Icon name="arrow-prev" size="14" />
      </SlickArrow>
    ),
  };

  return (
    <div className={cn("section", styles.section)}>
      <div className={cn("container", styles.container)}>
        <div className={styles.head}>
          <h2 className={cn("h2", styles.title)}>
            Let’s break some misconceptions, shall we?
          </h2>
          <div className={cn("info", styles.info)}>
            Offbeat sports are not what you think
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.col}>
            <div className={styles.list}>
              {items.map((x, index) => (
                <div className={styles.item} key={index}>
                  <div
                    className={styles.number}
                    style={{ backgroundColor: x.color }}
                  >
                    0{index + 1}
                  </div>
                  <del>
                    <div className={styles.subtitle}>{x.title}</div>
                  </del>
                  <div className={styles.text}>{x.content}</div>
                </div>
              ))}
            </div>
            <Link className={cn("button", styles.button)} to="/get-started">
              Start your Sportifying Journey
            </Link>
          </div>
          <div className={styles.col}>
            <div className={styles.wrapper}>
              <Slider className="travel-slider" {...settings}>
                {gallery.map((item, index) => (
                  <div className={styles.gallery} key={index}>
                    <div className={cn("travel-bg", styles.bg)}>
                      <img
                        srcSet={`${item.srcSet} 2x`}
                        src={item.src}
                        alt="Travel"
                      />
                    </div>
                    <div className={styles.group}>
                      {item.images.map((x, index) => (
                        <div
                          className={cn("travel-preview", styles.preview)}
                          key={index}
                        >
                          {/* <Image
                            srcSet={`${x.srcSet} 2x`}
                            srcSetDark={`${x.srcSetDark} 2x`}
                            src={x.src}
                            srcDark={x.srcDark}
                            alt="Appraisal"
                          /> */}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Travel;
